import { render, staticRenderFns } from "./LotteryItem.vue?vue&type=template&id=3ce26cce&scoped=true&"
import script from "./LotteryItem.vue?vue&type=script&lang=js&"
export * from "./LotteryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce26cce",
  null
  
)

export default component.exports